import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartButtonComponent } from '@app/shared/components/cart-button/cart-button.component';

@NgModule({
  imports: [CommonModule],
  declarations: [CartButtonComponent],
  exports: [CartButtonComponent]
})
export class CartButtonModule {}
